if (!customElements.get('article-manuly')) {
  customElements.define(
    'article-manuly',
    class BlogArticle extends HTMLElement {

        constructor() {
            super();
            var tables = this.querySelectorAll("table");
            tables.forEach(element => {
                element.style.width = "unset";
                element.removeAttribute("width");
            });
        }

    });
}
